import _sfc_main from './SearchSuggester.vue2.js';
import normalizeComponent from '../../_virtual/_plugin-vue2_normalizer.js';

var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { directives: [{ name: "click-outside", rawName: "v-click-outside", value: _setup.onClickAway, expression: "onClickAway" }], staticClass: "fds-widget fds-search-suggester", class: { "fds-ui-loading": _setup.isLoadingStoreData } }, [_vm._t("root", function() {
    return [_vm._t("input", function() {
      return [_c("div", { staticClass: "fds-ui-input fds-search-suggester__input", attrs: { "role": "combobox", "aria-owns": `fds-search-suggester-results-${_setup.elementId}`, "aria-haspopup": "listbox", "aria-expanded": _setup.displayResultsBox ? "true" : "false" } }, [_vm._t("input:combobox", function() {
        return [_vm._t("input:combobox:label", function() {
          return [_c("label", { directives: [{ name: "show", rawName: "v-show", value: false, expression: "false" }], staticClass: "fds-ui-input__label", attrs: { "for": "search-suggester-input-box" } }, [_vm._v(_vm._s(_setup.translate("searchSuggester.inputPlaceholder")))])];
        }, null, { storeModule: _setup.storeModule, localizationSupport: _setup.localizationSupport, searchTerm: _setup.searchTerm, label: "searchSuggester.inputPlaceholder" }), _vm._t("input:combobox:field", function() {
          return [_c("div", { staticClass: "fds-ui-input__field" }, [_vm._t("input:combobox:field:icon", function() {
            return [_c("span", { staticClass: "fds-ui-icon fds-ui-icon--search" })];
          }, null, { searchTerm: _setup.searchTerm, onKeyPressEnter: _setup.onKeyPressEnter }), _c("input", { directives: [{ name: "model", rawName: "v-model", value: _setup.searchTerm, expression: "searchTerm" }], ref: "searchInput", attrs: { "id": "search-suggester-input-box", "type": "text", "autocomplete": "off", "placeholder": _setup.translate("searchSuggester.inputPlaceholder"), "aria-label": _setup.translate("searchSuggester.inputPlaceholder"), "aria-activedescendant": _setup.displayResultsBox ? _setup.getActiveDescendant() : void 0, "aria-autocomplete": "both" }, domProps: { "value": _setup.searchTerm }, on: { "input": [function($event) {
            if ($event.target.composing)
              return;
            _setup.searchTerm = $event.target.value;
          }, function($event) {
            return _setup.onInput($event);
          }], "click": function($event) {
            return _setup.onFormFocus();
          }, "focusin": function($event) {
            return _setup.onFormFocus();
          }, "focusout": function($event) {
            return _setup.onFormLooseFocus();
          }, "keydown": [function($event) {
            if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"]))
              return null;
            $event.preventDefault();
          }, function($event) {
            if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"]))
              return null;
            $event.preventDefault();
          }, function($event) {
            if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"]))
              return null;
            $event.preventDefault();
          }, function($event) {
            if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"]))
              return null;
            return _setup.onKeyPressUp();
          }, function($event) {
            if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"]))
              return null;
            return _setup.onKeyPressDown();
          }, function($event) {
            if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"]))
              return null;
            return _setup.onKeyPressEscape();
          }], "keypress": function($event) {
            if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter"))
              return null;
            return _setup.onKeyPressEnter();
          } } }), _vm._t("input:combobox:field:action", function() {
            return [_setup.searchTerm.length > 0 ? _c("button", { staticClass: "fds-ui-button fds-ui-button--text", attrs: { "type": "button", "aria-label": _setup.translate("searchSuggester.clearSearchTerm") }, on: { "click": function($event) {
              $event.preventDefault();
              return _setup.clearSearch();
            }, "keypress": function($event) {
              if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter"))
                return null;
              return _setup.clearSearch();
            } } }, [_c("span", { staticClass: "fds-ui-icon fds-ui-icon--close" })]) : _vm._e()];
          }, null, { localizationSupport: _setup.localizationSupport, clearSearch: _setup.clearSearch, searchTerm: _setup.searchTerm, label: "searchSuggester.clearSearchTerm" })], 2)];
        }, null, {
          storeModule: _setup.storeModule,
          localizationSupport: _setup.localizationSupport,
          searchTerm: _setup.searchTerm,
          displayResultsBox: _setup.displayResultsBox,
          onFormFocus: _setup.onFormFocus,
          onFormLooseFocus: _setup.onFormLooseFocus,
          onKeyPressEscape: _setup.onKeyPressEscape,
          onKeyPressEnter: _setup.onKeyPressEnter,
          onKeyPressDown: _setup.onKeyPressDown,
          onKeyPressUp: _setup.onKeyPressUp,
          clearSearch: _setup.clearSearch,
          searchTermValidationErrorsBag: _setup.searchTermValidationErrorsBag,
          label: "searchSuggester.inputPlaceholder"
        }), _vm._t("input:combobox:error", null, null, { storeModule: _setup.storeModule, localizationSupport: _setup.localizationSupport, searchTermValidationErrorsBag: _setup.searchTermValidationErrorsBag })];
      }, null, {
        storeModule: _setup.storeModule,
        localizationSupport: _setup.localizationSupport,
        searchTerm: _setup.searchTerm,
        displayResultsBox: _setup.displayResultsBox,
        onFormFocus: _setup.onFormFocus,
        onFormLooseFocus: _setup.onFormLooseFocus,
        onKeyPressEscape: _setup.onKeyPressEscape,
        onKeyPressEnter: _setup.onKeyPressEnter,
        onKeyPressDown: _setup.onKeyPressDown,
        onKeyPressUp: _setup.onKeyPressUp,
        clearSearch: _setup.clearSearch,
        searchTermValidationErrorsBag: _setup.searchTermValidationErrorsBag,
        label: "searchSuggester.inputPlaceholder"
      })], 2)];
    }, null, {
      storeModule: _setup.storeModule,
      localizationSupport: _setup.localizationSupport,
      searchTerm: _setup.searchTerm,
      onFormFocus: _setup.onFormFocus,
      onKeyPressEscape: _setup.onKeyPressEscape,
      onKeyPressEnter: _setup.onKeyPressEnter,
      onKeyPressDown: _setup.onKeyPressDown,
      onKeyPressUp: _setup.onKeyPressUp,
      clearSearch: _setup.clearSearch,
      searchTermValidationErrorsBag: _setup.searchTermValidationErrorsBag
    }), _vm._t("results", function() {
      return [_setup.displayResultsBox ? _c("div", { staticClass: "fds-search-suggester__results fds-search-results", attrs: { "id": `fds-search-suggester-results-${_setup.elementId}`, "role": "listbox", "aria-labelledby": "search-suggester-input-box" } }, [_c("div", { staticClass: "fds-search-results__container" }, [_setup.showResults(_setup.storeData) ? [_vm._l(_setup.groupedResults, function(group, groupIndex) {
        return [_vm._t("results:group", function() {
          return [_c("div", { key: `${groupIndex}`, staticClass: "fds-search-results__group" }, [_vm._t("results:group:title", function() {
            return [group.assetClass && group.items.length > 0 ? _c("div", { staticClass: "fds-search-results__title" }, [_c(_setup.HoistComponent, [_c(_setup.UiAssetClassBadge, { attrs: { "locale": _vm.locale, "asset-class": group.assetClass } })], 1)], 1) : _vm._e()];
          }, null, { group, groupIndex, localizationSupport: _setup.localizationSupport }), _vm._l(group.items, function(item, index) {
            return [_vm._t("results:group:item", function() {
              return [_c("div", { key: `fds-search-result${group.assetClass}-item-${index}`, ref: (element) => _setup.populateSuggestionRef(groupIndex, index, element), refInFor: true, staticClass: "fds-search-results__item", class: { "fds-search-results__item--active": _setup.isItemSelected(groupIndex, index) }, attrs: { "id": _setup.getItemIdentifier(groupIndex, index), "aria-selected": _setup.getItemIdentifier(groupIndex, index) === _setup.getActiveDescendant(), "role": "option" }, on: { "click": function($event) {
                $event.preventDefault();
                return _setup.onSelectSearchResult(item);
              } } }, [_vm._t("results:group:item:name", function() {
                return [_c("div", { staticClass: "fds-search-results__item-info" }, [_c("span", { staticClass: "fds-search-results__item-name", domProps: { "innerHTML": _vm._s(_setup.highlight(_setup.textFormat(item.name), _setup.searchTerm)) } }), _c("span", { staticClass: "fds-search-results__item-isin", domProps: { "innerHTML": _vm._s(_setup.highlight(_setup.textFormat(item.isin), _setup.searchTerm)) } })])];
              }, null, { item, localizationSupport: _setup.localizationSupport, highlight: _setup.highlight, searchTerm: _setup.searchTerm }), _vm._t("results:group:item:asset-class", function() {
                return [!group.assetClass ? [_c(_setup.HoistComponent, [_c(_setup.UiAssetClassBadge, { attrs: { "locale": _vm.locale, "asset-class": _setup.getAssetClass(item) } })], 1)] : _vm._e()];
              }, null, { item, group, localizationSupport: _setup.localizationSupport })], 2)];
            }, null, {
              storeModule: _setup.storeModule,
              localizationSupport: _setup.localizationSupport,
              group,
              groupIndex,
              index,
              item,
              isItemSelected: _setup.isItemSelected,
              searchTerm: _setup.searchTerm,
              highlight: _setup.highlight,
              getItemIdentifier: _setup.getItemIdentifier,
              getActiveDescendant: _setup.getActiveDescendant,
              onSelectSearchResult: _setup.onSelectSearchResult
            })];
          })], 2)];
        }, null, {
          storeModule: _setup.storeModule,
          localizationSupport: _setup.localizationSupport,
          group,
          groupIndex,
          isItemSelected: _setup.isItemSelected,
          searchTerm: _setup.searchTerm,
          highlight: _setup.highlight,
          getItemIdentifier: _setup.getItemIdentifier,
          getActiveDescendant: _setup.getActiveDescendant,
          onSelectSearchResult: _setup.onSelectSearchResult
        })];
      })] : _setup.showNoResults(_setup.storeData) ? [_vm._t("results:item(no-results)", function() {
        return [_c("div", { staticClass: "fds-search-suggester__no-results" }, [_vm._v(_vm._s(_setup.translate("searchSuggester.noResults")))])];
      }, null, { storeModule: _setup.storeModule, localizationSupport: _setup.localizationSupport, label: "searchSuggester.noResults" })] : _vm._e()], 2), _vm._t("results:footer", function() {
        return [_setup.hasOnAllSearchResultsClickListener ? _c("div", { staticClass: "fds-search-results__all-results" }, [_vm._t("results:footer:content", function() {
          return [_c("button", { staticClass: "fds-ui-button fds-ui-button--text", attrs: { "type": "button" }, on: { "click": function($event) {
            return _setup.onAllSearchResultsClick();
          } } }, [_vm._v(" " + _vm._s(_setup.translate("searchSuggester.allSearchResults")) + " ")])];
        }, null, { storeModule: _setup.storeModule, localizationSupport: _setup.localizationSupport, hasOnAllSearchResultsClickListener: _setup.hasOnAllSearchResultsClickListener, onAllSearchResultsClick: _setup.onAllSearchResultsClick, label: "searchSuggester.allSearchResults" })], 2) : _vm._e()];
      }, null, { storeModule: _setup.storeModule, localizationSupport: _setup.localizationSupport, hasOnAllSearchResultsClickListener: _setup.hasOnAllSearchResultsClickListener, onAllSearchResultsClick: _setup.onAllSearchResultsClick, label: "searchSuggester.allSearchResults" })], 2) : _vm._e()];
    }, null, {
      storeModule: _setup.storeModule,
      localizationSupport: _setup.localizationSupport,
      hasOnAllSearchResultsClickListener: _setup.hasOnAllSearchResultsClickListener,
      onAllSearchResultsClick: _setup.onAllSearchResultsClick,
      searchTerm: _setup.searchTerm,
      groupedResults: _setup.groupedResults,
      displayResultsBox: _setup.displayResultsBox,
      highlight: _setup.highlight,
      isItemSelected: _setup.isItemSelected,
      onClickAway: _setup.onClickAway,
      onFormFocus: _setup.onFormFocus,
      onKeyPressEscape: _setup.onKeyPressEscape,
      onKeyPressEnter: _setup.onKeyPressEnter,
      onKeyPressDown: _setup.onKeyPressDown,
      onKeyPressUp: _setup.onKeyPressUp,
      clearSearch: _setup.clearSearch,
      onSelectSearchResult: _setup.onSelectSearchResult,
      elementId: _setup.elementId,
      showResults: _setup.showResults,
      showNoResults: _setup.showNoResults
    })];
  }, null, {
    storeModule: _setup.storeModule,
    localizationSupport: _setup.localizationSupport,
    hasOnAllSearchResultsClickListener: _setup.hasOnAllSearchResultsClickListener,
    onAllSearchResultsClick: _setup.onAllSearchResultsClick,
    searchTerm: _setup.searchTerm,
    groupedResults: _setup.groupedResults,
    displayResultsBox: _setup.displayResultsBox,
    highlight: _setup.highlight,
    isItemSelected: _setup.isItemSelected,
    onClickAway: _setup.onClickAway,
    onFormFocus: _setup.onFormFocus,
    onFormLooseFocus: _setup.onFormLooseFocus,
    onKeyPressEscape: _setup.onKeyPressEscape,
    onKeyPressEnter: _setup.onKeyPressEnter,
    onKeyPressDown: _setup.onKeyPressDown,
    onKeyPressUp: _setup.onKeyPressUp,
    clearSearch: _setup.clearSearch,
    onSelectSearchResult: _setup.onSelectSearchResult,
    showResults: _setup.showResults,
    showNoResults: _setup.showNoResults
  })], 2);
};
var _sfc_staticRenderFns = [];
_sfc_render._withStripped = true;
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null,
  null,
  null
);
__component__.options.__file = "/home/ubuntu/actions-runner/_work/library/library/packages/library/src/components/search-suggester/SearchSuggester.vue";
var SearchSuggester = __component__.exports;

export { SearchSuggester as default };
